import { styled } from '@/styled-system/jsx';
import { Anchor } from '@zillow/constellation-10';

export const StyledAnchor = styled(Anchor, {
  base: {
    fontWeight: 'bold',
    color: 'white',
    _visited: { color: 'white' },
  },
});
